import axios from 'axios';

// Create an Axios instance
const api = axios.create({
 // baseURL: 'https://api.drsa.sdga.in/index.php/', // Replace with your base URL
 baseURL: 'https://api.adyapeathusa.org/index.php/',
 

});


// export const mediaURL = "https://api.drsa.sdga.in/uploads/";
export const mediaURL = "https://api.adyapeathusa.org/uploads/";
// Request interceptor (e.g., for adding authorization headers)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Example: Retrieve token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers['Basic'] = 'drsa';
    return config;
  },
  (error) => {
    return Promise.reject(error)
  }
);

// Response interceptor (e.g., handle errors globally)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Example: Handle 401 errors globally
    if (error.response && error.response.status === 401) {
      console.error('Unauthorized. Redirecting to login...');
    }
    return Promise.reject(error);
  }
);

export default api;
